import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

import { onMounted, onUpdated, ref } from "vue";
import { kebabCase } from "lodash";

interface Props {
  /** manually specified heading id */
  id?: string;
  /** manually specified heading level */
  level?: number;
  /** icon to show next to text */
  icon?: string;
  /** fall back icon */
  fallbackIcon?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeading',
  props: {
    id: null,
    level: null,
    icon: null,
    fallbackIcon: null
  },
  setup(__props: any) {

const props = __props as {
  /** manually specified heading id */
  id?: string;
  /** manually specified heading level */
  level?: number;
  /** icon to show next to text */
  icon?: string;
  /** fall back icon */
  fallbackIcon?: string;
}



/** tag of heading (default to blank to avoid conflict with automatic level) */
const tag = ref("");
/** hash link of heading */
const link = ref("");

/** heading ref */
const heading = ref<HTMLElement>();

/** get heading level/tag, i.e. h1, h2, h3, etc */
function getTag() {
  /** if level manually specified, just use that */
  if (props.level) return "h" + props.level;

  /**
   * otherwise, determine automatically based on heading's position in document
   * https://dequeuniversity.com/rules/axe/4.1/page-has-heading-one
   */

  /** heading element */
  const element = heading.value;
  /** section element */
  const parent = element?.parentElement as HTMLElement;

  /** if heading is first in section */
  const firstHeading = element?.matches("*:first-child");
  /** if section is first in main */
  const firstSection = parent?.matches("*:first-child");

  /** determine level */
  if (firstSection) {
    if (firstHeading) return "h1";
    else return "h2";
  } else {
    if (firstHeading) return "h2";
    else return "h3";
  }
}

/** determine link from text content of heading */
function getLink() {
  /**
   * per accessibility conventions, h1's should only appear once and near top of
   * doc. thus, anchors aren't useful for them.
   */
  if (tag.value === "h1") return "";
  else return kebabCase(props.id || heading.value?.textContent || "");
}

/** update tag and link on mount and change */
function update() {
  tag.value = getTag();
  link.value = getLink();
}
onMounted(update);
onUpdated(update);

return (_ctx: any,_cache: any) => {
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_AppLink = _resolveComponent("AppLink")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(tag.value || 'div'), {
    id: link.value,
    ref_key: "heading",
    ref: heading
  }, {
    default: _withCtx(() => [
      (__props.icon)
        ? (_openBlock(), _createBlock(_component_AppIcon, {
            key: 0,
            icon: __props.icon,
            fallback: __props.fallbackIcon,
            class: "icon"
          }, null, 8, ["icon", "fallback"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default"),
      (link.value)
        ? (_openBlock(), _createBlock(_component_AppLink, {
            key: 1,
            to: '#' + link.value,
            class: "anchor",
            "aria-label": 'Link to this section'
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AppIcon, { icon: "link" })
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["id"]))
}
}

})